module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("按钮 - <uk-button>")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('uk-button', {
    attrs: {
      "color": _vm.color,
      "active": _vm.isActive,
      "disabled": _vm.isDisabled,
      "size": _vm.size,
      "width": _vm.width,
      "icon": _vm.icon
    }
  }, [_vm._v("Default\n    ")])], 1), _vm._v(" "), _c('p', [_c('code-block', [_vm._v(_vm._s(_vm.usages.basic))])], 1), _vm._v(" "), _c('h3', [_vm._v("属性")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-striped uk-table-condensed"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('td', [_vm._v("颜色")]), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.color),
      expression: "color"
    }],
    staticClass: "uk-width-1-1",
    on: {
      "change": function($event) {
        _vm.color = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', [_vm._v("undefined")]), _vm._v(" "), _c('option', [_vm._v("primary")]), _vm._v(" "), _c('option', [_vm._v("success")]), _vm._v(" "), _c('option', [_vm._v("danger")])])])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isActive),
      expression: "isActive"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isActive) ? _vm._i(_vm.isActive, null) > -1 : (_vm.isActive)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isActive,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.isActive = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isActive = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isActive = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isDisabled),
      expression: "isDisabled"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isDisabled) ? _vm._i(_vm.isDisabled, null) > -1 : (_vm.isDisabled)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isDisabled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.isDisabled = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isDisabled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isDisabled = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('td', [_vm._v("尺寸")]), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.size),
      expression: "size"
    }],
    staticClass: "uk-width-1-1",
    on: {
      "change": function($event) {
        _vm.size = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', [_vm._v("undefined")]), _vm._v(" "), _c('option', [_vm._v("mini")]), _vm._v(" "), _c('option', [_vm._v("small")]), _vm._v(" "), _c('option', [_vm._v("large")])])])]), _vm._v(" "), _c('tr', [_vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('td', [_vm._v("宽度")]), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.width),
      expression: "width"
    }],
    staticClass: "uk-width-1-1",
    on: {
      "change": function($event) {
        _vm.width = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', [_vm._v("undefined")]), _vm._v(" "), _c('option', [_vm._v("1-1")]), _vm._v(" "), _c('option', [_vm._v("1-2")]), _vm._v(" "), _c('option', [_vm._v("1-3")]), _vm._v(" "), _c('option', [_vm._v("1-4")]), _vm._v(" "), _c('option', [_vm._v("1-5")]), _vm._v(" "), _c('option', [_vm._v("1-6")])])])]), _vm._v(" "), _c('tr', [_vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('td', [_vm._v("图标")]), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.icon),
      expression: "icon"
    }],
    staticClass: "uk-width-1-1",
    on: {
      "change": function($event) {
        _vm.icon = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', [_vm._v("undefined")]), _vm._v(" "), _c('option', [_vm._v("comment")]), _vm._v(" "), _c('option', [_vm._v("edit")]), _vm._v(" "), _c('option', [_vm._v("check")]), _vm._v(" "), _c('option', [_vm._v("cloud-upload")]), _vm._v(" "), _c('option', [_vm._v("clone")]), _vm._v(" "), _c('option', [_vm._v("cart-plus")]), _vm._v(" "), _c('option', [_vm._v("credit-card")]), _vm._v(" "), _c('option', [_vm._v("plus")])])])])])]), _vm._v(" "), _c('h2', [_vm._v("按钮组 - <uk-button-group>")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('uk-button-group', {
    attrs: {
      "type": _vm.buttonType
    }
  }, [_c('uk-button', {
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v("选项1")]), _vm._v(" "), _c('uk-button', {
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v("选项2")]), _vm._v(" "), _c('uk-button', {
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v("选项3")])], 1), _vm._v(" "), _c('p', [_c('code-block', [_vm._v(_vm._s(_vm.usages.group))])], 1), _vm._v(" "), _c('h3', [_vm._v("属性")]), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-striped uk-table-condensed"
  }, [_vm._m(19), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('td', [_vm._v("类型")]), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buttonType),
      expression: "buttonType"
    }],
    staticClass: "uk-width-1-1",
    on: {
      "change": function($event) {
        _vm.buttonType = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', [_vm._v("undefined")]), _vm._v(" "), _c('option', [_vm._v("checkbox")]), _vm._v(" "), _c('option', [_vm._v("radio")])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("属性")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', {
    staticClass: "uk-width-2-6"
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("体验")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("color")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("String")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("undefined")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("active")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("Boolean")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("false")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("disabled")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("Boolean")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("false")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("size")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("String")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("undefined")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("width")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("String")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("undefined")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("icon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("String")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("undefined")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("属性")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', {
    staticClass: "uk-width-2-6"
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("体验")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("type")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("String")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("undefined")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-35169062!./~/vue-loader/lib/selector.js?type=template&index=0!./src/docs/UkButton.doc.vue
// module id = 283
// module chunks = 2